import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import { isEmpty } from 'ramda';

import {
  SurchargesMaintenance,
  SurchargesMaintenanceDetails,
  SurchargesMaintenanceFlag
} from './types';

import {
  createSurchargesMaintenanceDetails,
  deleteSurchargesMaintenanceDetails,
  saveSurchargesMaintenanceDetails
} from 'RestAPIs/admin';

import { showErrorSnackbar } from 'components/shared/Snackbar';

export const toPercentage = (value: number): number => {
  return new Decimal(value / 100).toNumber();
};

export const fromPercentage = (value: number): number => {
  return new Decimal(value * 100).toNumber();
};

export const convertBaseForSave = (data): SurchargesMaintenance => {
  return { code: data.code, name: data.name };
};

export const convertDetailsForSave = (
  data,
  surchargeId
): SurchargesMaintenanceDetails => {
  return {
    ...data,
    surchargeId,
    method: Number(data.method),
    surcharge1Perc: toPercentage(data.surcharge1Perc),
    surcharge3Perc: toPercentage(data.surcharge3Perc),
    serviceBrId: data.flags.SERVICE_BR_DEFAULT_FLAG ? null : data.serviceBrId,
    serviceBrName: data.flags.SERVICE_BR_DEFAULT_FLAG
      ? null
      : data.serviceBrName,
    valid: {
      from: dayjs(data.valid.from).startOf('day').toISOString(),
      to: dayjs(data.valid.to).endOf('day').toISOString()
    }
  };
};

export const convertFlagsObjectToArray = (
  flags: SurchargesMaintenanceDetails['flags']
): SurchargesMaintenanceFlag[] => {
  const flagsArr: SurchargesMaintenanceFlag[] = [];
  for (const flag in flags) {
    if (flags[flag]) {
      flagsArr.push(SurchargesMaintenanceFlag[flag]);
    }
  }
  return flagsArr;
};

export const convertDetailsTableData = (data) => {
  return !isEmpty(data)
    ? data.map((surchDetails) => ({
        ...surchDetails,
        surcharge1Perc: fromPercentage(surchDetails.surcharge1Perc),
        surcharge3Perc: fromPercentage(surchDetails.surcharge3Perc)
      }))
    : [];
};

export const handleSaveDetails = (data, deletedIds: number[]) => {
  if (data.details && data.details.length > 0) {
    const requestsArray: Promise<AxiosResponse>[] = [];
    data.details
      .filter((value) => value.isCommitted)
      .forEach((detail) => {
        if (detail.surchargeDynId) {
          requestsArray.push(saveSurchargesMaintenanceDetails(detail));
        } else {
          requestsArray.push(createSurchargesMaintenanceDetails(detail));
        }
      });
    deletedIds.forEach((id) => {
      requestsArray.push(deleteSurchargesMaintenanceDetails(data, id));
    });

    return Promise.all(requestsArray).catch((error) =>
      showErrorSnackbar(error)
    );
  }

  return Promise.resolve();
};
